import { IRON, SKY, TERTIARY_TEXT } from 'styles/Colors';
import { SET_DATA } from 'helpers/Constants';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from 'components/forms/Checkbox';
import React from 'react';

const containerStyle = {
  alignItems: 'start',
  color: TERTIARY_TEXT,
  display: 'flex'
};

const footerStyle = {
  fontSize: '87.5%',
  fontStyle: 'italic',
  marginTop: '0.5rem'
};

const privacyPolicyStyle = {
  color: TERTIARY_TEXT,
  textAlign: 'center',
  fontSize: '87.5%'
};

const disclosureStyle = {
  color: IRON,
  fontSize: '0.875rem'
};

const phoneStyle = {
  color: SKY,
  textDecoration: 'underline',
  whiteSpace: 'nowrap'
};

function PhoneNumberLink() {
  return (
    <a css={phoneStyle} href='tel:18009909130'>
      (800) 990-9130
    </a>
  );
}

function BillingRelatedNotificationsDisclosure() {
  return (
    <div css={disclosureStyle}>
      I consent to receive SMS text messages at the mobile number I have
      provided for account and billing-related notifications and alerts from
      OppLoans. I acknowledge and consent to receive calls from OppLoans from an
      automatic telephone dialing system to the number provided. I understand
      that I can opt-out of receiving these messages at any time by replying
      STOP, and I can request assistance by replying HELP. For Support, call{' '}
      <PhoneNumberLink />. Message and data rates may apply. Message frequency
      varies. No mobile information will be shared with third parties/affiliates
      for marketing/promotional purposes. All other categories exclude text
      messaging originator opt-in data and consent; this information will not be
      shared with any third parties.
    </div>
  );
}
function MarketingRelatedNotificationsDisclosure() {
  return (
    <div css={disclosureStyle}>
      I consent to receive SMS marketing messages at the mobile number I have
      provided. I acknowledge and consent to receive calls from OppLoans from an
      automatic telephone dialing system to the number provided. I understand
      that I can opt-out of receiving these messages at any time by replying
      STOP, and I can request assistance by replying HELP. For Support call{' '}
      <PhoneNumberLink />. Message and data rates may apply. Message frequency
      may vary and is up to 4 messages a week. Mobile Information will not be
      shared with third parties/affiliates for marketing/promotional purposes.
    </div>
  );
}

function MarketingDisclosure({ style = {} }) {
  const billingNotificationsDisclosure = useSelector(
    (state) => state.billingNotificationsDisclosure
  );
  const marketingDisclosure = useSelector((state) => state.marketingDisclosure);
  const dispatch = useDispatch();

  return (
    <>
      <div css={[containerStyle, style]}>
        <Checkbox
          id='billingNotificationsDisclosure'
          name='billingNotificationsDisclosure'
          value={billingNotificationsDisclosure || false}
          checked={billingNotificationsDisclosure || false}
          onChange={(e) => {
            dispatch({
              type: SET_DATA,
              payload: { billingNotificationsDisclosure: e.target.checked }
            });
          }}
          additionalCheckboxStyle={{ borderRadius: 0 }}
          additionalLabelStyle={{
            fontSize: '10px',
            display: 'flex',
            placeItems: 'center stretch',
            padding: '0.5rem'
          }}
        />
        <BillingRelatedNotificationsDisclosure />
      </div>

      <div css={[containerStyle, style]}>
        <Checkbox
          id='marketingDisclosure'
          name='marketingDisclosure'
          value={marketingDisclosure || false}
          checked={marketingDisclosure || false}
          onChange={(e) => {
            dispatch({
              type: SET_DATA,
              payload: { marketingDisclosure: e.target.checked }
            });
          }}
          additionalCheckboxStyle={{ borderRadius: 0 }}
          additionalLabelStyle={{
            fontSize: '10px',
            display: 'flex',
            placeItems: 'center stretch',
            padding: '0.5rem'
          }}
        />

        <MarketingRelatedNotificationsDisclosure />
      </div>

      <div css={[privacyPolicyStyle, style]}>
        <div>
          For more information see our{' '}
          <a
            href='https://privacy.opploans.com/'
            target='_blank'
            rel='noreferrer'
          >
            privacy policy
          </a>{' '}
          and
          <a
            href='https://www.opploans.com/terms-of-use/'
            target='_blank'
            rel='noreferrer'
          >
            {' '}
            terms of use
          </a>
        </div>
        <div style={footerStyle}>
          This authorization is not a condition for purchasing any goods or
          services.
        </div>
      </div>
    </>
  );
}

export default MarketingDisclosure;
